(function () {
    function init(el) {
        var hamburger = el.querySelector('.rcatc-site-header__hamburger');
        var mobileMenu = el.querySelector('.rcatc-site-header__mobile-menu');
        if (!hamburger || !mobileMenu) return;

        var stickyHeader = document.querySelector('header.elementor-location-header');
        if (stickyHeader) {
            function onScroll() {
                stickyHeader.classList.toggle('is-scrolled', window.scrollY > 10);
            }
            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        function open() {
            el.classList.add('is-open');
            hamburger.setAttribute('aria-expanded', 'true');
            mobileMenu.setAttribute('aria-hidden', 'false');
        }

        function close() {
            el.classList.remove('is-open');
            hamburger.setAttribute('aria-expanded', 'false');
            mobileMenu.setAttribute('aria-hidden', 'true');
        }

        hamburger.addEventListener('click', function () {
            el.classList.contains('is-open') ? close() : open();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && el.classList.contains('is-open')) {
                close();
                hamburger.focus();
            }
        });

        document.addEventListener('click', function (e) {
            if (!el.contains(e.target) && el.classList.contains('is-open')) {
                close();
            }
        });

        // Keep data-count in sync after WooCommerce fragment updates so the
        // CSS visibility rule ([data-count]:not([data-count="0"])) works correctly.
        document.body.addEventListener('wc_fragments_refreshed', function () {
            var countEl = el.querySelector('.rcatc-site-header__cart-count');
            if (countEl) {
                countEl.setAttribute('data-count', countEl.textContent.trim());
            }
        });
    }

    document.querySelectorAll('.rcatc-site-header').forEach(init);
})();
